/** Discard late responses after a store switch, including A -> B -> A. */
export function createMailboxRequestScope() {
  let storeId = '';
  let revision = 0;
  const requests = new Map<string, number>();
  return {
    select(nextStoreId: string) {
      if (nextStoreId === storeId) return;
      storeId = nextStoreId;
      revision += 1;
      requests.clear();
    },
    begin(resource: string, requestStoreId: string) {
      const requestRevision = revision;
      const request = (requests.get(resource) ?? 0) + 1;
      // An old callback must not invalidate the current store's request.
      if (requestStoreId === storeId) requests.set(resource, request);
      return () => requestStoreId === storeId
        && requestRevision === revision
        && requests.get(resource) === request;
    },
  };
}
